// extracted by mini-css-extract-plugin
export default {"chartTitle":"ranked-performance-chart_chartTitle__c2BX3","emptyStateWrapper":"ranked-performance-chart_emptyStateWrapper__cwjs2"};